window.theme.component('video-player-vivo', el => {
    const playButton = el.querySelector('.video-play-button');
    const buttonWrapper = el.querySelector('.play-button-wrapper');

    if (playButton) {
        playButton.addEventListener('click', function() {
            const iframe = el.querySelector('.video-player iframe');

            let src = iframe.getAttribute('src');
            if (src.includes('mute=1')) {
                src = src.replace('mute=1', 'mute=0');
                iframe.setAttribute('src', src);
            }

            buttonWrapper.style.display = 'none';
        });
    }
});
